<template>
  <div class="App">
    <router-view />
    <notifications
      group="notificateDiv"
      classes="noticateStyle"
      position="top right"
      :width="450"
      animation-name="v-fade-left"
    />
  </div>
</template>


<script>
import Settings from "@/settings.js";

export default {
  name: "app",
  data() {
    return {};
  },
  methods: {},
  async mounted() {
    let setts = await Settings;
    const link = document.querySelector("[rel='icon']");
    link.setAttribute("href", "/"+setts.favicon);
  },
};
</script>

<style lang="scss">
body,
html {
  height: 100%;
  width: 100%;
}

.App {
  min-height: 100vh;
  max-width: 100vw;
}

/*CSS FOR NOTIFICATIONS BOX*/
.noticateStyle {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  text-align: left;
  font-size: 14px;
  margin: 10px;
  padding: 20px;
  margin-bottom: 0;
  align-items: center;
  justify-content: center;
  background: #e8f9f0;
  min-width: 420px;
  border: 2px solid #d0f2e1 !important;

  &,
  & > div {
    box-sizing: border-box;
  }

  .custom-template-icon {
    flex: 0 1 auto;
    color: #15c371;
    font-size: 32px;
    padding: 0 10px;
  }
  .custom-template-close {
    flex: 0 1 auto;
    padding: 0 20px;
    font-size: 16px;
    opacity: 0.2;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }
  .custom-template-content {
    padding: 10px;
    flex: 1 0 auto;
    .custom-template-title {
      letter-spacing: 1px;
      text-transform: uppercase;
      font-size: 10px;
      font-weight: 600;
    }
  }

  &.pepito {
    background: #ffb648 !important;
    border-left-color: #f48a06 !important;
  }
}

.v-fade-left-enter-active,
.v-fade-left-leave-active,
.v-fade-left-move {
  transition: all 0.5s;
}
.v-fade-left-enter,
.v-fade-left-leave-to {
  opacity: 0;
  transform: translateX(450px) scale(0.2);
}
</style>
